angular.module('rjmNg.services').factory 'htmlTableService', [
  "dateService"
  "chartFormatterService"
  "metricDataTypes"
  "figureService"
  "rjqlStringConstants"
  (
    dateService
    chartFormatterService
    metricDataTypes
    figureService
    rjqlStringConstants
  ) ->

    # Get metric data types from constants file
    dataTypeConstants = metricDataTypes.DATA_TYPES

    # Generates a properly formatted html table
    generateTableFromFigureData : (figureData, metrics, timeInterval, reportType, groupByValues) ->
      report = []

      switch reportType
        when 'dimensionView' then report = @_generateDimensionView(figureData, metrics, timeInterval, groupByValues)
        else report = @_generateNormalView(figureData, metrics, timeInterval)

      return report

    # This is used to build the header rows of the table.
    generateHeadersFromFigure : (figure, viewType, timeInterval, isCohortFigure=false, isTimeBasedCohortFigure=false) ->
      dimensionNames = @_getDimensionNamesFromFigure(figure)

      # Define the first row of the header
      headers = [[]]
      unless timeInterval is 'None'
        if viewType is 'dimensionView'
          for column in figure.query.select.columns
            if isCohortFigure
              if not isTimeBasedCohortFigure or dimensionNames[0] is rjqlStringConstants.RJQL_TIME
                firstColumnHeader = 'Cohort Group'
              else
                firstColumnHeader = dimensionNames[0]
            else
              firstColumnHeader = ''
            headers[0].push firstColumnHeader for dim in dimensionNames
        else
          headers[0].push ''
      else
        headers[0].push ''

      if viewType is 'dimensionView' and timeInterval != 'None'
        # Add the second and following rows of the header if it isn't cohort report
        unless isCohortFigure
          headers.push dimensionNames

        for column in figure.data.columns
          for measure in figure.query.select.measures
            # Fill up the first row of the header
            headers[0].push dateService.format(column[0], timeInterval, isCohortFigure)
            # Fill the second and following rows of the header if it isn't cohort report
            unless isCohortFigure
              if measure.label? # Calculated metrics have labels
                headers[1].push measure.label
              else if measure is ":value"
                headers[1].push figure.query.from.alias
              else
                headers[1].push measure[0] # This is for multi-source metric aliases
      else if viewType is 'dimensionView' and timeInterval is 'None'
        headers[0] = dimensionNames.concat figureService.getUnDimensionedMeasureNames(figure)
      else
        headers[0] = headers[0].concat figureService.getUnDimensionedMeasureNames(figure)

      # Since the header is built by treating these values as HTML, ensure that
      # each doesn't contain any raw HTML which might otherwise be executed.
      for headerRow, y in headers
        headers[y] = headerRow.map _.escape

      return headers

    # Ungrouped metrics, possibly over time
    _generateNormalView : (figureData, metrics, timeInterval) ->
      report = []

      # Get prefix, suffix, data type, range, and median for each metric
      measureData = []

      for row in figureData.rows
        for dataset, datasetIndex in row.data
          measureData.push @_getMeasureDataFromFigureData figureData, dataset, datasetIndex
      # Generate a transposed view of this data for a table
      # This might seem like a lot of comments for a simple operation
      # but it's easy to get confused about what is supposed to be
      # happening here
      for col, colIndex in figureData.columns
        # Generating each row of the table report
        reportRow = []

        # Pass in the name first
        if figureData.headers.columns[0] is ":time"
          reportRow.push chartFormatterService.sanitize dateService.format(col[0], timeInterval, false)
        else
          reportRow.push col # In this case, RJQL is returning a string instead of an array

        # Go through each row of data
        for row, rowIndex in figureData.rows
          # Go through each metric
          for dataset, datasetIndex in row.data
            # Get the prefix, suffix, datatype, range min/max, and median for this metric
            [prefix, suffix, dataType, range, median] = measureData[datasetIndex]

            #Adjust the display value based on that info
            adjustedValue = chartFormatterService.getValueAdjustedForDataType(dataset[colIndex], prefix, suffix, dataType, range, median)
            # Push the adjusted value onto the report row
            reportRow.push adjustedValue

        # Push this new row into our report
        report.push reportRow

      return report

    # For when we have metrics grouped by dimensions
    _generateDimensionView : (figureData, metrics, timeInterval, groupByValues) ->

      report = []
      intervals = []
      headerRow = []

      measureData = []
      for metric, metricIndex in metrics
        metricDataset = (row.data[metricIndex][0] for row in figureData.rows)
        md = @_getMeasureDataFromFigureData figureData, metricDataset, metricIndex
        measureData[metricIndex] = md

      for interval in figureData.columns
        intervals.push interval[0]
        for metric in metrics
          headerRow.push "#{metric.alias}"

      for row in figureData.rows
        # If we have no data, RJQL returns an array with one null value
        if row?
          currentRow = @_getEscapedRowHeader row.name, figureData.headers.rows

          for interval, intervalIndex in figureData.columns
            for metric, metricIndex in metrics
              [prefix, suffix, dataType, range, median] = measureData[metricIndex]
              adjustedValue = chartFormatterService.getValueAdjustedForDataType(
                row.data[metricIndex]?[intervalIndex],
                prefix, suffix, dataType, range, median
              )
              currentRow.push adjustedValue
          report.push currentRow
      return report

    _nameToTypeObject: (name) ->
      if name is null or name is "[NULL]"
        return type: "null"
      else if name is "" or name is "[blank]"
        return type: "blank"
      else
        return
          type: "value"
          value: name

    _getEscapedRowHeader : (rowName, rowHeaders) ->
      if Array.isArray(rowName)
        names = rowName.map(@_nameToTypeObject)
      else
        names = [@_nameToTypeObject(rowName)]

      names = @_fixNames(names, rowHeaders).map (name) ->
        if name.type is "null"
          "<em>null</em>"
        else if name.type is "blank"
          "<em>blank</em>"
        else
          _.escape name.value

      return [].concat names

    # If we have unbound dimensions, we need to make sure we have the right
    # number of cells, otherwise datatables gets angry
    _fixNames : (names, rowHeaders) ->
      for header, index in rowHeaders
        unless names[index]?
          names.push
            type: "null"
      return names

    # Gets information used to format display values from the rjql response
    _getMeasureDataFromFigureData : (figureData, dataset, metricIndex) ->
      prefix = @_getPrefixFromFigureData(figureData, metricIndex) ? ''
      suffix = @_getSuffixFromFigureData(figureData, metricIndex) ? ''
      dataType = @_getDataTypeFromFigureData(figureData, metricIndex) ? dataTypeConstants.nonMonetary
      range = null
      median = null

      # Only these data types need the range to calculate display precision
      if dataType is dataTypeConstants.currency or dataType is dataTypeConstants.nonMonetary
        range =
          min: Math.min dataset...
          max: Math.max dataset...

      # Only these data types need the median to calculate display suffix
      if dataType is dataTypeConstants.seconds or dataType is dataTypeConstants.bytes
        median = @_getDatasetMedian dataset

      return [prefix, suffix, dataType, range, median]

    _getDatasetMedian : (dataset) ->
      return null if dataset.length is 0

      nonEmptyData = []
      for datum in dataset when datum isnt 0 and datum isnt null
        nonEmptyData.push datum

      if nonEmptyData.length is 0 then return 0

      sorted = nonEmptyData.slice().sort((a, b) -> a - b)
      if sorted.length % 2 is 1 # odd number of elements, middle element is median
        sorted[(sorted.length - 1) / 2]
      else # even number of elements, take average of middle two elements
        (sorted[(sorted.length / 2) - 1] + sorted[(sorted.length / 2)]) / 2

    _getDataTypeFromFigureData : (figureData, metricIndex) ->
      dataType = figureData.headers.measures?[metricIndex]?.dataType
      dataType ?= ''
      return dataType

    _getPrefixFromFigureData : (figureData, metricIndex) ->
      prefix = figureData.headers.measures?[metricIndex]?.prefix
      prefix ?= ''
      return prefix

    _getSuffixFromFigureData : (figureData, metricIndex) ->
      suffix = figureData.headers.measures?[metricIndex]?.suffix
      suffix ?= ''
      return suffix

    # Returns dimension names from a figure object
    _getDimensionNamesFromFigure : (figure) ->
      dimensionNames = []
      if figure.data?.headers.rows?
        dimensionNames = figure.data.headers.rows

      # Quick fix to change nulls to empty strings until GA issue is resolved
      dimensionNames = dimensionNames.map (name) -> return name ?= ''

      return dimensionNames

]
